import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import { gridFilterModelSelector } from '@mui/x-data-grid-pro';

const ClientFilter = (props) => {
    // client state is now controlled by parent
    const { client, setClient } = props;
    const [clients, setClients] = useState([]);

    useEffect(() => {
        let clients = new Set();
        props.rows.forEach(row => {
            if (row.client) {
                clients.add(row.client);
            }
        });
        setClients([...clients].map(client => ({ client: client })));
    }, [props.rows]);

    useEffect(() => {
        let gridFilterModel = gridFilterModelSelector(props.apiRef.current.state);
            let newFilterModel = { ...gridFilterModel };

        if (client === null) {
            newFilterModel.items = newFilterModel.items.filter(item => item.field !== "client");
            props.apiRef.current.setFilterModel(newFilterModel);
        } else {
            newFilterModel.items = newFilterModel.items.filter(item => item.field !== "client");
            newFilterModel.items.push({ field: "client", operator: "equals", value: client.client, id: 3 });
            props.apiRef.current.setFilterModel(newFilterModel);
        }
    }, [client]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', minWidth: "100px", width: "100%" }}>
            <AutoComplete
                value={client}
                onChange={(e, value) => setClient(value)}
                options={clients}
                sx={{ width: "100%" }}
                size="small"
                getOptionLabel={(option) => option.client}
                renderInput={(params) => 
                    <TextField 
                        {...params} 
                        label="Client" 
                        variant="outlined"
                />}
            />
        </Box>
    )
}

export default ClientFilter;